import React, {createContext, useState} from "react";
import Notification from "../components/common/Notification";
import GlobalAccountService from "../services/GlobalAccountService";

export const GlobalAccountContext = createContext("GlobalAccountContext");

const GlobalAccountContextProvider = ({children}) => {

    const [globalAccounts, setGlobalAccounts] = useState([]);
    const [globalAccount, setGlobalAccount] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [totalElements, setTotalElements] = useState(0);

    const getGlobalAccountList = async params => {

        try {
            setLoading(true);
            setErrorMsg('');

            const res = await GlobalAccountService.getGlobalAccountList({...params, size: 100});

            setGlobalAccounts(res.data.content);
            setTotalElements(res.data.totalElements);
            setLoading(false);

            return res.data.content;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    const addGlobalAccount = async data => {

        try {
            setLoading(true);
            const res = await GlobalAccountService.addGlobalAccount(data)
            setLoading(false);

            Notification("success", "Created", "Global Account Created Successfully");

            return res.data;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    const editGlobalAccount = async (id, data) => {

        try {
            setLoading(true);
            await GlobalAccountService.editGlobalAccount(id, data);
            setLoading(false);

            Notification("success", "Updated", "Global Account Updated Successfully");

            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    const deleteGlobalAccount = async id => {

        try {
            setLoading(true);
            await GlobalAccountService.deleteGlobalAccount(id);
            setLoading(false);

            Notification("success", "Deleted", "Global Account Deleted Successfully");

            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }

    const getGlobalAccountById = async id => {

        try {
            setLoading(true);
            setErrorMsg('');

            const res = await GlobalAccountService.getGlobalAccountById(id);

            setGlobalAccount(res.data);
            setLoading(false);

            return res.data;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";

            if (error.message === 'Network Error') {
                _error = error.message;
            }

            if (error.response && error.response.data) {
                _error = error.response.data.message;
            }
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }

    }


    return (
        <GlobalAccountContext.Provider
            value={{
                loading,
                errorMsg,
                totalElements,
                globalAccounts,
                globalAccount,
                getGlobalAccountList,
                getGlobalAccountById,
                addGlobalAccount,
                editGlobalAccount,
                deleteGlobalAccount,
            }}
        >
            {children}
        </GlobalAccountContext.Provider>
    );
}

export default GlobalAccountContextProvider;
